import type { ReactNode } from 'react';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BrandL, LabelL } from '#src/atoms/typography/index.tsx';
import type { Unit } from '#src/lib/style.ts';

const Root = styled(Vertical)`
  width: 100%;
  flex: 1;
  background-image:
    linear-gradient(to top, var(--c-black), var(--c-black) 5%, transparent 40%),
    linear-gradient(to right, rgba(var(--c-rgb-black), 0.5), transparent 20%);
  padding: var(--double-unit);
`;

const ChipWithBorder = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: var(--half-unit);
  white-space: nowrap;
  min-height: 32px;
  padding: var(--half-unit) var(--intermediate-unit);
  border: 1px solid var(--c-white);
  border-radius: 16px;
  background: var(--c-nl-200);
  color: var(--c-white);
  text-transform: uppercase;
  text-align: center;
`;

const Title = styled(BrandL)`
  white-space: pre-wrap;
`;

const TitleWrapper = styled.div`
  width: var(--title-max-width, 100%);
  text-align: center;
`;

type Props = {
  title: ReactNode;
  chipTitle?: ReactNode;
  children: ReactNode;
  style?: React.CSSProperties;
  gap?: Unit;
  titleMaxWidth?: string;
};

export const Section = ({
  title,
  chipTitle,
  children,
  style,
  gap = 8,
  titleMaxWidth,
}: Props) => {
  return (
    <Root center gap={gap} style={style}>
      <Vertical className="text-center" center gap={1}>
        {!!chipTitle && (
          <ChipWithBorder>
            <LabelL>{chipTitle}</LabelL>
          </ChipWithBorder>
        )}
        <TitleWrapper
          style={{ '--titleMaxWidth': titleMaxWidth } as CSSProperties}
        >
          <Title as="h2">{title}</Title>
        </TitleWrapper>
      </Vertical>
      {children}
    </Root>
  );
};
